import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from './logic/store/Store';
import { PersistGate } from 'redux-persist/integration/react';
import 'antd/dist/antd.css';
import { migrateLocalStorageToIndexedDb } from './logic/store/migrateLocalStorageToIndexedDb';
import { initGoogleAnalytics } from './tracing/GoogleAnalytics';

async function main()
{
	// Initialize GA4 with the right property for the current skin (GHX vs Enogen).
	initGoogleAnalytics();

	// Perform migration from localStorage to indexedDB
	await migrateLocalStorageToIndexedDb();

	// Now render the app
	ReactDOM.render(
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<App />
			</PersistGate>
		</Provider>,
		document.getElementById('root')
	);
}

main();